module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-husk-blue-dc5bed8e00a9a4e9b2f37a614e5477a7.svg";